import React, { useState } from 'react';
import HorizontalSwitcher from '../../horizontalSwitcher/HorizontalSwitcher';
import Form from 'react-bootstrap/Form';
import { ToastType } from '../../../store/ui/toasts/toastsTypes';
import { useDispatch } from 'react-redux';
import { showToastNotification } from '../../../store/ui/toasts/toastsActions';
import BzmDropzone from '../../dropzone/core/BzmDropzone';

interface WsdlDropzoneProps {
  onChange: (wsdlValue: string) => void;
  value: string;
}

const WsdlDropzone = (props: WsdlDropzoneProps) => {
  const height = 150;
  const dispatch = useDispatch();
  const [isSwapped, setIsSwapped] = useState(false);

  const textArea = (
    <Form.Control
      autoComplete={'off'}
      as="textarea"
      style={{ height: height + 'px' }}
      name="content"
      onChange={(e: any) => props.onChange(e.target.value)}
      placeholder={'Insert Schema (XSD) as Plain Text ...'}
      value={props.value}
    />
  );

  /**
   * Read contents of the file and put it to the textarea.
   * @param files
   */
  const onDropAccepted = async <T extends File>(files: T[]) => {
    try {
      const file = files[0];
      const text = await file.text();
      props.onChange(text);
      setIsSwapped(false);
      dispatch(
        showToastNotification(
          ToastType.Success,
          'File Content Loaded',
          `Content from file ${file.name} has been successfully loaded.`,
        ),
      );
    } catch (e) {
      dispatch(showToastNotification(ToastType.Danger, 'Cannot process selected file'));
    }
  };

  const onDropRejected = () => {
    dispatch(showToastNotification(ToastType.Danger, 'Invalid file', 'Select a text file with valid xsd.'));
  };

  const dropZone = (
    <BzmDropzone
      accept={'.txt, .xsd'}
      title={'Upload Schema (XSD) File'}
      subTitle={'Click or Drag & Drop File to This Area'}
      onDropRejected={onDropRejected}
      onDropAccepted={onDropAccepted}
      height={height + 'px'}
      multiple={false}
    />
  );

  return (
    <HorizontalSwitcher
      leftPanel={{ content: textArea, title: 'Copy / Paste Schema (XSD) as Plain Text' }}
      rightPanel={{ content: dropZone, title: 'Upload Schema (XSD) File' }}
      height={height}
      swapPanelWidth={18}
      isSwapped={isSwapped}
      toggle={() => setIsSwapped(!isSwapped)}
    />
  );
};

export default WsdlDropzone;
